import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class Toast508Service {
  public translation: any;
  constructor(
    private translate: TranslateService
  ) {
    this.translate.get(['CAREER_CLOSE_BUTTON']).subscribe((obj) => {
      this.translation = obj;
    });
  }

  // This checkin(https://github.com/ionic-team/ionic/pull/11543/files) is in open state. Once the changes got merged to ionic, 
  // we don't need below logic for accessibility.
  toFocus() {
    setTimeout(() => {
      let closeBtn = <HTMLButtonElement>document.querySelector('button.toast-button');
      if (closeBtn)
        closeBtn.setAttribute('aria-label', this.translation.CAREER_CLOSE_BUTTON);
      let elm = <HTMLDivElement>document.querySelector('ion-toast div');
      if (elm) {
        elm.setAttribute('tabindex', '-1');
        elm.setAttribute('role', 'alert');
        elm.focus();
      }
    }, 300);

  }
}


// WEBPACK FOOTER //
// ./src/providers/toast-508.service.ts